import React, { useEffect, useRef, useState } from 'react';
import './ImageGrid.css'; 

const ImageGrid = () => {
  const imgsRef = useRef([]);
  const [isInViewport, setIsInViewport] = useState(false);

  const checkIfInViewport = () => {
    const viewportHeight = window.innerHeight;
    imgsRef.current.forEach((img) => {

      if (img && img.getBoundingClientRect) {
        if (img.getBoundingClientRect().top < viewportHeight) {
          img.style.animationPlayState = 'running';
        }
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkIfInViewport);

    checkIfInViewport();

    return () => {
      window.removeEventListener('scroll', checkIfInViewport);
    };
  }, []);

  return (
    <div>
      <section className='imageGridSection'>
        {[
        "./dashboard1.png",
          "./dashboard2.png",
          "./kali1.png",
          "./dashboard3.png",
          "./kali2.png",
          "./ipDetails.png",
          "./dashboard4.png",
          "./alerts.png",
          "./logs.png",
          "./settings.png",
          "./register.png",
          "./email.jpg"
          
          
        ].map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`image-${index}`}
            ref={(el) => {
              if (el) {
                imgsRef.current[index] = el;
              }
            }}
          />
        ))}

      </section>
    </div>
  );
};

export default ImageGrid;
